"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
exports.__esModule = true;
exports.toInvestorsPressReleaseSlice = void 0;
var utils_1 = require("@lglp/utils");
var types_1 = require("../../types");
var slice_1 = require("./slice");
var toInvestorsPressReleaseSlice = function (data) {
    return utils_1.compact(__assign({}, slice_1.toSlice(data, types_1.SliceType.InvestorsPressRelease)));
};
exports.toInvestorsPressReleaseSlice = toInvestorsPressReleaseSlice;
//# sourceMappingURL=investors-press-release-slice.js.map